/* ============================================
   Don Chacho — B2B v2 JS
   Archivo: assets/dc-b2b-v2.js
   ============================================ */
(function(){
  'use strict';

  /* ---- Food Service Builder ---- */
  function initFSBuilder() {
    // Tipo de negocio
    document.querySelectorAll('.dc-fs-v2__tipo-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.dc-fs-v2__tipo-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        updateResumen();
      });
    });

    // Presentación
    document.querySelectorAll('.dc-fs-v2__pres-item').forEach(function(item) {
      item.addEventListener('click', function() {
        document.querySelectorAll('.dc-fs-v2__pres-item').forEach(function(i){ i.classList.remove('active'); });
        item.classList.add('active');
        updateResumen();
      });
    });

    // Sabores
    document.querySelectorAll('.dc-fs-v2__sabor').forEach(function(sabor) {
      sabor.addEventListener('click', function() {
        sabor.classList.toggle('active');
        updateResumen();
      });
    });

    // Cantidad
    var cantInput = document.querySelector('.dc-fs-v2__cant-input');
    if (cantInput) {
      cantInput.addEventListener('input', function() { updateResumen(); });
    }

    updateResumen();
  }

  function updateResumen() {
    var tipo = document.querySelector('.dc-fs-v2__tipo-btn.active');
    var pres = document.querySelector('.dc-fs-v2__pres-item.active');
    var sabores = document.querySelectorAll('.dc-fs-v2__sabor.active');
    var cantInput = document.querySelector('.dc-fs-v2__cant-input');
    var cant = cantInput ? parseInt(cantInput.value) || 1 : 1;

    var tipoEl = document.querySelector('.dc-fs-v2__res-tipo');
    var presEl = document.querySelector('.dc-fs-v2__res-pres');
    var saboresEl = document.querySelector('.dc-fs-v2__res-sabores');
    var cantEl = document.querySelector('.dc-fs-v2__res-cant');

    if (tipoEl && tipo) tipoEl.textContent = tipo.querySelector('.dc-fs-v2__tipo-nombre')?.textContent || '—';
    if (presEl && pres) presEl.textContent = pres.querySelector('.dc-fs-v2__pres-nombre')?.textContent || '—';
    if (saboresEl) {
      var nombres = Array.from(sabores).map(function(s){ return s.getAttribute('data-nombre') || s.textContent; });
      saboresEl.textContent = nombres.length > 0 ? nombres.join(' + ') : '—';
    }
    if (cantEl) cantEl.textContent = cant + (cant === 1 ? ' unidad' : ' unidades');
  }

  /* ---- Mayoreo Add to Cart ---- */
  function initMayoreoCart() {
    document.querySelectorAll('.dc-may-v2__pack-add-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.getAttribute('data-variant-id');
        var qty = parseInt(btn.getAttribute('data-qty') || '1');
        if (!variantId) return;
        var orig = btn.textContent;
        btn.textContent = 'Agregando...';
        btn.disabled = true;
        // Agregar producto + envío fijo como line item property
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: qty,
            properties: { 'Tipo': 'Mayoreo', 'Envío fijo': '$400 MXN' }
          })
        })
        .then(function(r){ return r.json(); })
        .then(function() {
          btn.textContent = '✓ Agregado';
          btn.style.background = '#3B9E52';
          showToast('✓ Pack agregado · Recuerda que el envío es $400 fijo');
          updateCartCount();
          setTimeout(function() {
            btn.textContent = orig;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        })
        .catch(function() { btn.textContent = orig; btn.disabled = false; });
      });
    });
  }

  /* ---- Food Service Cotización ---- */
  function initFSCotizar() {
    var btn = document.querySelector('.dc-fs-v2__cotizar-btn');
    var waBtn = document.querySelector('.dc-fs-v2__wa-btn');
    if (!btn) return;

    btn.addEventListener('click', function() {
      var tipo = document.querySelector('.dc-fs-v2__tipo-btn.active')?.querySelector('.dc-fs-v2__tipo-nombre')?.textContent || '';
      var pres = document.querySelector('.dc-fs-v2__pres-item.active')?.querySelector('.dc-fs-v2__pres-nombre')?.textContent || '';
      var sabores = Array.from(document.querySelectorAll('.dc-fs-v2__sabor.active')).map(function(s){ return s.getAttribute('data-nombre') || s.textContent; }).join(', ');
      var cant = document.querySelector('.dc-fs-v2__cant-input')?.value || '1';

      // Redirect to contact form with pre-filled info
      var form = document.querySelector('#dc-fs-form');
      if (form) {
        var msgField = form.querySelector('[name="contact[body][mensaje]"]');
        if (msgField) msgField.value = 'Tipo: ' + tipo + '\nPresentación: ' + pres + '\nSabores: ' + sabores + '\nCantidad: ' + cant;
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    if (waBtn) {
      waBtn.addEventListener('click', function() {
        var tipo = document.querySelector('.dc-fs-v2__tipo-btn.active')?.querySelector('.dc-fs-v2__tipo-nombre')?.textContent || '';
        var pres = document.querySelector('.dc-fs-v2__pres-item.active')?.querySelector('.dc-fs-v2__pres-nombre')?.textContent || '';
        var sabores = Array.from(document.querySelectorAll('.dc-fs-v2__sabor.active')).map(function(s){ return s.getAttribute('data-nombre') || s.textContent; }).join(', ');
        var msg = 'Hola Don Chacho, quiero cotizar un pedido Food Service:\n- Negocio: ' + tipo + '\n- Presentación: ' + pres + '\n- Sabores: ' + sabores;
        window.open('https://wa.me/521XXXXXXXXXX?text=' + encodeURIComponent(msg), '_blank');
      });
    }
  }

  /* ---- Toast ---- */
  function showToast(msg) {
    var t = document.querySelector('.dc-b2b-v2__toast');
    if (!t) { t = document.createElement('div'); t.className = 'dc-b2b-v2__toast'; t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(80px);background:#1e5541;color:#fff;font-family:"DM Sans",sans-serif;font-size:12px;font-weight:600;padding:12px 20px;border-radius:4px;z-index:100;transition:transform .3s;white-space:nowrap'; document.body.appendChild(t); }
    t.textContent = msg;
    t.style.transform = 'translateX(-50%) translateY(0)';
    setTimeout(function() { t.style.transform = 'translateX(-50%) translateY(80px)'; }, 3000);
  }

  /* ---- Cart count ---- */
  function updateCartCount() {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initFSBuilder();
    initMayoreoCart();
    initFSCotizar();
  });
})();